import { render, staticRenderFns } from "./PhotoCover.vue?vue&type=template&id=0d0861a6&"
import script from "./PhotoCover.vue?vue&type=script&lang=js&"
export * from "./PhotoCover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports